export const dict: Record<string, string> = {
  "ui.sessionReview.title": "Session changes",
  "ui.sessionReview.title.git": "Git changes",
  "ui.sessionReview.title.branch": "Branch changes",
  "ui.sessionReview.title.lastTurn": "Last turn changes",
  "ui.sessionReview.diffStyle.unified": "Unified",
  "ui.sessionReview.diffStyle.split": "Split",
  "ui.sessionReview.expandAll": "Expand all",
  "ui.sessionReview.collapseAll": "Collapse all",
  "ui.sessionReview.change.added": "Added",
  "ui.sessionReview.change.removed": "Removed",
  "ui.sessionReview.change.modified": "Modified",
  "ui.sessionReview.image.loading": "Loading...",
  "ui.sessionReview.image.placeholder": "Image",
  "ui.sessionReview.largeDiff.title": "Diff too large to render",
  "ui.sessionReview.largeDiff.meta": "Limit: {{limit}} changed lines. Current: {{current}} changed lines.",
  "ui.sessionReview.largeDiff.renderAnyway": "Render anyway",
  "ui.sessionReview.openFile": "Open file",
  "ui.sessionReview.selection.line": "line {{line}}",
  "ui.sessionReview.selection.lines": "lines {{start}}-{{end}}",

  "ui.fileMedia.kind.image": "image",
  "ui.fileMedia.kind.audio": "audio",
  "ui.fileMedia.state.removed": "Removed {{kind}} file.",
  "ui.fileMedia.state.loading": "Loading {{kind}}...",
  "ui.fileMedia.state.error": "Unable to load {{kind}}.",
  "ui.fileMedia.state.unavailable": "{{kind}} preview unavailable.",
  "ui.fileMedia.binary.title": "Binary file",
  "ui.fileMedia.binary.description.path": "{{path}} is binary.",
  "ui.fileMedia.binary.description.default": "Binary content",

  "ui.lineComment.label.prefix": "Comment on ",
  "ui.lineComment.label.suffix": "",
  "ui.lineComment.editorLabel.prefix": "Commenting on ",
  "ui.lineComment.editorLabel.suffix": "",
  "ui.lineComment.placeholder": "Add comment",
  "ui.lineComment.submit": "Comment",

  "ui.sessionTurn.steps.show": "Show steps",
  "ui.sessionTurn.steps.hide": "Hide steps",
  "ui.sessionTurn.summary.response": "Response",
  "ui.sessionTurn.diff.showMore": "Show more changes ({{count}})",
  "ui.sessionTurn.diffs.changed": "Changed",
  "ui.sessionTurn.diffs.showAll": "Show all",
  "ui.sessionTurn.diffs.showLess": "Show less",
  "ui.sessionTurn.diffs.more": "+{{count}} more files",

  "ui.sessionTurn.retry.retrying": "retrying",
  "ui.sessionTurn.retry.inSeconds": "in {{seconds}}s",
  "ui.sessionTurn.retry.attempt": "attempt #{{attempt}}",
  "ui.sessionTurn.retry.attemptLine": "{{line}} - attempt #{{attempt}}",
  "ui.sessionTurn.retry.geminiHot": "gemini is way too hot right now",
  "ui.sessionTurn.error.freeUsageExceeded": "Free usage exceeded",
  "ui.sessionTurn.error.addCredits": "Add credits",

  "ui.sessionTurn.status.delegating": "Delegating work",
  "ui.sessionTurn.status.planning": "Planning next steps",
  "ui.sessionTurn.status.gatheringContext": "Exploring",
  "ui.sessionTurn.status.gatheredContext": "Explored",
  "ui.sessionTurn.status.searchingCodebase": "Searching the codebase",
  "ui.sessionTurn.status.searchingWeb": "Searching the web",
  "ui.sessionTurn.status.makingEdits": "Making edits",
  "ui.sessionTurn.status.runningCommands": "Running commands",
  "ui.sessionTurn.status.working": "Working",
  "ui.sessionTurn.status.completed": "Done",
  "ui.sessionTurn.verification.passed": "Verified",
  "ui.sessionTurn.verification.failed": "Verification failed",
  "ui.sessionTurn.verification.unverified": "Not verified",
  "ui.sessionTurn.verification.not_required": "Verification not required",
  "ui.sessionTurn.verification.checks.one": "{{count}} check",
  "ui.sessionTurn.verification.checks.other": "{{count}} checks",
  "ui.sessionTurn.verification.details.show": "Show verification details",
  "ui.sessionTurn.verification.details.hide": "Hide verification details",
  "ui.sessionTurn.verification.exitCode": "Exit code: {{code}}",
  "ui.sessionTurn.verification.noChecks": "Files changed, but no verification command was recorded.",
  "ui.sessionTurn.verification.attempts.one": "{{count}} automatic attempt",
  "ui.sessionTurn.verification.attempts.other": "{{count}} automatic attempts",
  "ui.sessionTurn.verification.requirement.missing": "Missing required check",
  "ui.sessionTurn.verification.requirement.optional": "Optional",
  "ui.sessionTurn.verification.review.passed": "Semantic review passed",
  "ui.sessionTurn.verification.review.failed": "Semantic review found issues",
  "ui.sessionTurn.verification.review.error": "Semantic review could not run",
  "ui.sessionTurn.verification.review.not_run": "Semantic review not run",
  "ui.sessionTurn.status.thinking": "Thinking",
  "ui.sessionTurn.status.thinkingWithTopic": "Thinking - {{topic}}",
  "ui.sessionTurn.status.thinkingPhrase.whirring": "Whirring",
  "ui.sessionTurn.status.thinkingPhrase.boondoggling": "Boondoggling",
  "ui.sessionTurn.status.thinkingPhrase.flummoxing": "Flummoxing",
  "ui.sessionTurn.status.thinkingPhrase.cooking": "Cooking",
  "ui.sessionTurn.status.thinkingPhrase.crafting": "Crafting",
  "ui.sessionTurn.status.thinkingPhrase.pondering": "Pondering",
  "ui.sessionTurn.status.thinkingPhrase.thinking": "Thinking",
  "ui.sessionTurn.status.thinkingPhrase.processing": "Processing",
  "ui.sessionTurn.status.gatheringThoughts": "Gathering thoughts",
  "ui.sessionTurn.status.consideringNextSteps": "Considering next steps",

  "ui.messagePart.diagnostic.error": "Error",
  "ui.messagePart.title.edit": "Editing",
  "ui.messagePart.title.edit.completed": "Edit completed",
  "ui.messagePart.title.write": "Writing",
  "ui.messagePart.title.write.completed": "Write completed",
  "ui.messagePart.option.typeOwnAnswer": "Type your own answer",
  "ui.messagePart.review.title": "Review your answers",
  "ui.messagePart.questions.dismissed": "Questions dismissed",
  "ui.messagePart.compaction": "Session compacted",
  "ui.messagePart.context.read.one": "{{count}} read",
  "ui.messagePart.context.read.other": "{{count}} reads",
  "ui.messagePart.context.search.one": "{{count}} search",
  "ui.messagePart.context.search.other": "{{count}} searches",
  "ui.messagePart.context.list.one": "{{count}} list",
  "ui.messagePart.context.list.other": "{{count}} lists",

  "ui.list.loading": "Loading",
  "ui.list.empty": "No results",
  "ui.list.clearFilter": "Clear filter",
  "ui.list.emptyWithFilter.prefix": "No results for",
  "ui.list.emptyWithFilter.suffix": "",

  "ui.fileSearch.placeholder": "Find",
  "ui.fileSearch.previousMatch": "Previous match",
  "ui.fileSearch.nextMatch": "Next match",
  "ui.fileSearch.close": "Close search",

  "ui.messageNav.newMessage": "New message",

  "ui.textField.copyToClipboard": "Copy to clipboard",
  "ui.textField.copyLink": "Copy link",
  "ui.textField.copied": "Copied",

  "ui.imagePreview.alt": "Image preview",
  "ui.scrollView.ariaLabel": "scrollable content",

  "ui.tool.read": "Read",
  "ui.tool.loaded": "Read",
  "ui.tool.list": "List",
  "ui.tool.memory": "Memory",
  "ui.tool.memory.remembered": "Remembered",
  "ui.tool.memory.undo": "Undo",
  "ui.tool.memory.undone": "Removed from memory",
  "ui.tool.glob": "Finding files",
  "ui.tool.grep": "Searching in file",
  "ui.tool.search.completed": "Search completed",
  "ui.tool.task": "Task",
  "ui.tool.task.completed": "Task completed",
  "ui.tool.webfetch": "Webfetch",
  "ui.tool.webfetch.completed": "Fetch completed",
  "ui.tool.websearch": "Web Search",
  "ui.tool.shell": "Shell",
  "ui.tool.shell.completed": "Command completed",
  "ui.tool.patch": "Patch",
  "ui.tool.patch.completed": "Patch completed",
  "ui.tool.todos": "To-dos",
  "ui.tool.todos.read": "Read to-dos",
  "ui.tool.questions": "Questions",
  "ui.tool.questions.answered": "Questions answered",
  "ui.tool.agent": "{{type}} Agent",
  "ui.tool.agent.default": "Agent",
  "ui.tool.error.title": "{{tool}} error",
  "ui.tool.skill": "Skill",
  "ui.tool.skill.error": "Skill error",
  "ui.tool.skill.loading": "Loading skill {{skill}}",
  "ui.tool.skill.preparing": "Preparing skill {{skill}}",
  "ui.tool.skill.using": "Using skill {{skill}}",
  "ui.tool.skill.used": "Used skill {{skill}}",
  "ui.tool.details.path": "Path",
  "ui.tool.details.pattern": "Pattern",
  "ui.tool.details.include": "Include",
  "ui.tool.details.query": "Query",
  "ui.tool.details.url": "URL",
  "ui.tool.details.agent": "Agent",
  "ui.tool.details.task": "Task",
  "ui.tool.details.session": "Session",
  "ui.tool.details.description": "Description",

  "ui.basicTool.called": "Called `{{tool}}`",
  "ui.toolErrorCard.failed": "Failed",
  "ui.toolErrorCard.copyError": "Copy error",

  "ui.common.file.one": "file",
  "ui.common.file.other": "files",
  "ui.common.question.one": "question",
  "ui.common.question.other": "questions",

  "ui.common.add": "Add",
  "ui.common.back": "Back",
  "ui.common.cancel": "Cancel",
  "ui.common.confirm": "Confirm",
  "ui.common.dismiss": "Dismiss",
  "ui.common.close": "Close",
  "ui.common.download": "Download",
  "ui.common.next": "Next",
  "ui.common.submit": "Submit",

  "ui.permission.deny": "Deny",
  "ui.permission.allowAlways": "Allow always",
  "ui.permission.allowOnce": "Allow once",

  "ui.message.expand": "Expand message",
  "ui.message.collapse": "Collapse message",
  "ui.message.copy": "Copy",
  "ui.message.copyMessage": "Copy message",
  "ui.message.forkMessage": "Fork to new session",
  "ui.message.revertMessage": "Revert message",
  "ui.message.copyResponse": "Copy response",
  "ui.message.copied": "Copied",
  "ui.message.chatLink": "Chat",
  "ui.message.duration.seconds": "{{count}}s",
  "ui.message.duration.minutesSeconds": "{{minutes}}m {{seconds}}s",
  "ui.message.interrupted": "Interrupted",
  "ui.message.queued": "Queued",
  "ui.message.attachment.alt": "attachment",
  "ui.message.attachment.notPublished": "attachment not published — files stay on the author's computer",

  "ui.patch.action.deleted": "Deleted",
  "ui.patch.action.created": "Created",
  "ui.patch.action.moved": "Moved",
  "ui.patch.action.patched": "Patched",

  "ui.question.subtitle.answered": "{{count}} answered",
  "ui.question.answer.none": "(no answer)",
  "ui.question.review.notAnswered": "(not answered)",
  "ui.question.multiHint": "Select all answers that apply",
  "ui.question.singleHint": "Select one answer",
  "ui.question.custom.placeholder": "Type your answer...",
}
